export default __webpack_public_path__ + "static/media/Wildmight Gloves.479e08cc.jpg";